import { AbstractModel } from './abstract-model';
import { Payment } from './payment';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { ReservationDetail } from './reservation-detail';

@inheritSerialization(AbstractModel)
export class ReservationChargeDetail extends AbstractModel {
  @autoserialize
  amount: number;

  @autoserialize
  completed: boolean;

  @autoserialize
  description: string;

  @autoserialize
  paid: boolean;

  @autoserializeAs(Payment)
  payment: Payment;

  @autoserializeAs(ReservationDetail)
  reservationDetail: ReservationDetail;
}
